import React from "react";
import { ActionButton, SpacingPlaceholder } from "./SharepointButton.styles";
import CloudIcon from "@mui/icons-material/Cloud";

const SharepointButton = ({ tender }) => {
    const path = tender.sharepoint_link;
    const isVisible = tender.tender_progress !== "source_documents" || tender.tender_sub_step !== "upload";

    const clickHandler = () => {
        window.open(path, '_blank');
    };

    return isVisible ? (
        <ActionButton data-testid="sharepoint-button" onClick={clickHandler}>
            <CloudIcon />
        </ActionButton>
    ) : (
        <SpacingPlaceholder />
    );
};

export default SharepointButton;